<template>
  <div class="accountList">
    <div v-for="(account, index) in accounts" @click="chooseAccount(index)" :key="index" class="accountRow">
      <div>Email: <span class="boldText">{{ account.user.email }}</span></div>
      <div>User Id: <span class="boldText">{{ account.user.uid }}</span></div>
      <div>Status: <span :class="`${account.user.status}Status`">{{ account.user.status }}</span></div>
      <div>Last country: {{ account.user.lastCountry.toUpperCase() }}</div>
      <div>Register country: {{ account.user.regCountry.toUpperCase() }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accounts: Array
  },
  methods: {
    chooseAccount (i) {
      this.$store.commit('search/setSearchAccount', this.accounts[i])
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .accountList {
    margin: 40px 0;
    .accountRow {
      padding: 15px 10px;
      border-bottom: 1px solid #dddddd;
      cursor: pointer;
      &:hover{
        background: #f8f8f8;
      }
      .boldText{
        font-weight: 500;
      }
    }
  }
</style>
